import { FormControl, FormHelperText, InputBase, InputBaseProps } from '@mui/material';
import { StyleObj } from '../../../../@types';

const styles: StyleObj = {
  input: {
    color: 'neutral.800',
    backgroundColor: 'neutral.25',
    borderRadius: 2,
    height: 44,
    padding: '10px',
    '& input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #F8F8F8 inset !important',
      WebkitTextFillColor: '#1a1a1a !important',
    },
  },
  helperText: {
    color: 'error.main',
    backgroundColor: 'neutral.25',
    p: 1,
    m: 0,
  },
};

type StyledInputProps = InputBaseProps & {
  helperText?: string;
};

const StyledInput = ({ helperText, ...inputProps }: StyledInputProps) => {
  if (helperText) {
    return (
      <FormControl fullWidth={inputProps.fullWidth} error={inputProps.error}>
        <InputBase {...inputProps} sx={styles.input} />
        <FormHelperText sx={styles.helperText}>{helperText}</FormHelperText>
      </FormControl>
    );
  }
  return <InputBase {...inputProps} sx={styles.input} />;
};

export default StyledInput;
